import _LogoDark from './SconLogoDark.png';
import _LogoLight from './SconLogoLight.png';
import _SconIcon from './scon.png';

export const LogoDark = _LogoDark;
export const LogoLight = _LogoLight;
export const SconIcon = _SconIcon;